
import {
  defineComponent, ref,
} from 'vue';
import {ElDropdown, ElDropdownMenu, ElDropdownItem} from 'element-plus';

export default defineComponent({
  name: 'event-navigation-dropdown',
  components: {
    ElDropdown,
    ElDropdownMenu,
    ElDropdownItem,
  },
  props: {
    events: Array,
    eventLabel: String,
    eventsParent: Array,
    labelTitle: String,
  },
  setup(props) {
    let options;
    const activeLabel = ref(props.eventLabel);
    const meetingLabelWithoutYear = props.labelTitle?.slice(0, -4);

    if (props.events) {
      options = props.events?.sort(function (event1: any, event2: any) {
        if (event1?.nav_title && event2?.nav_title) {
          return event1.nav_title - event2.nav_title;
        } else {
          return event1;
        }
      });
    } else if (props.eventsParent) {
      options = props.eventsParent?.sort(function (event1: any, event2: any) {
        if (event1?.nav_title && event2?.nav_title) {
          return event1.nav_title - event2.nav_title;
        } else {
          return event1;
        }
      });
    }


    options?.reverse();

    return {
      options,
      activeLabel,
      meetingLabelWithoutYear,
    };
  },
});

